module.exports = __webpack_public_path__ + "img/title.d6783740.png";